export default __webpack_public_path__ + "static/B0230-5eed44dfafd66c13d1ddf5a8c0c1ade2.png";